export interface TranslationResult {
  tabId: TabId;
  tabSectionKey: TabSectionKey;
  attributeKey: AttributeKey;
  attributeValue: string;
  languageCode?: string;
}

export interface UpdateTranslation {
  attributeKey: string;
  attributeValues: AttributeValues[];
  adminUser: string;
}

export interface AttributeValues {
  attributeValue: string;
  language: string;
}

export enum ModeType {
  FIND = "FIND",
  TRANSLATE = "TRANSLATE",
}

export interface findOrReplaceParams {
  word: string;
  mode: ModeType;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: string;
}

export interface TranslationPaginatedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: TranslationResult[];
}

export interface PortalLanguageTranslation {
  languageCode: string;
  translation: string;
}

// export interface ReplaceTranslationAttributes = {
//   attributeKey: string;
//   attributeValue: string;
//   tabId: string;
//   tabSectionKey: string;
// };

export interface ReplaceTranslationBodyParams {
  wordFind: string;
  wordReplace: string;
  translations: PortalLanguageTranslation[];
  attributes: TranslationResult[];
  adminUser: string;
}

export type TabId =
  | "appFrame"
  | "home"
  | "login"
  | "forgot-password"
  | "new-password"
  | "portal-configuration"
  | "portal-design"
  | "portal-translation"
  | "portal-pages"
  | "portal-settings"
  | "user-attributes";

export type TabSectionKey =
  | "mainMenu"
  | "adminPortalMenu"
  | "navBar"
  | "header"
  | "assignements"
  | "loginHeader"
  | "loginForm"
  | "forgotPasswordHeader"
  | "forgotPasswordForm"
  | "forgotPasswordInfo"
  | "setNewPasswordHeader"
  | "setNewPasswordForm"
  | "passwordReset"
  | "portalGrid"
  | "addPortalModal"
  | "editLanguages"
  | "designElements"
  | "pages"
  | "portalSettings"
  | "userAttributesGrid"
  | "userAttributeModal"
  | "gpc"
  | "general"
  | "login"
  | "home";

export type AttributeKey =
  // appFrame
  | "home"
  | "adminConsole"
  | "getBack"
  | "portalDesign"
  | "portalTranslation"
  | "portalPage"
  | "portalSetting"
  | "assignmentAssignement"
  | "userAttributes"
  | "search"
  | "viewProfile"
  | "logOut"
  // home header
  | "welcomeBack"
  | "activeCourses"
  | "activeAssignments"
  | "complete"
  | "partiallyComplete"
  | "toBeComplete"
  | "learners"
  | "lessonsCompleted"
  | "hoursOfLearning"
  // home assignements
  | "myAssignements"
  | "filter"
  | "filters"
  | "hideFilters"
  | "groups"
  | "all"
  | "completed"
  | "pending"
  | "save"
  | "clearAll"
  | "filtersApplied"
  | "courses"
  | "policies"
  | "surveys"
  // login
  | "loginText"
  | "loginDsc"
  | "email"
  | "password"
  | "btnForgotPassword"
  | "btnLogin"
  // forgot-password
  | "forgotPasswordText"
  | "forgotPasswordDsc"
  | "btnReset"
  | "backTologin"
  | "checkMailText"
  | "checkMailDsc"
  | "notReceive"
  | "clickToResend"
  // new-password
  | "setNewPasswordText"
  | "setNewPasswordDsc"
  | "activateAccount"
  | "activateAccountDsc"
  | "newPassword"
  | "repeatPassword"
  | "criteria1"
  | "criteria2"
  | "criteria3"
  | "criteria4"
  | "passwordResetText"
  | "passwordResetDsc"
  | "btnLogin"
  | "btnReset"
  | "btnActivate"
  // portal-configuration
  | "portalConfiguration"
  | "portals"
  | "btnAddNewPortal"
  | "btnManagePortals"
  | "name"
  | "url"
  | "languages"
  | "authoringTool"
  | "customTranslation"
  | "spoofingEmail"
  | "btnEdit"
  | "showRows"
  | "btnPrevious"
  | "btnNext"
  | "btnAll"
  | "addNewPortalText"
  | "subDomain"
  | "typeOfPortal"
  | "parentPortal"
  | "subPortal"
  | "additionalFeaturesServices"
  | "language"
  | "editLanguageText"
  | "btnSave"
  // portal-design
  | "logoTitle"
  | "logoSubtitle"
  | "certificateLogoTitle"
  | "certificateLogoSubtitle"
  | "faviconTitle"
  | "landscapeLogoTitle"
  | "squareLogoTitle"
  | "pixelsText"
  | "uploadImageText"
  | "backgroundTitle"
  | "pageBackgroundImageTitle"
  | "pageBackgroundImageSubtitle"
  | "backgroundTransparencyText"
  | "pageBackgroundColorTitle"
  | "primaryText"
  | "secondaryText"
  | "sidebarMenuTitle"
  | "sidebarText"
  | "textColorsTitle"
  | "navbarTitle"
  | "navbarBackgroundColorTitle"
  | "navbarText"
  | "navbarDropdownTitle"
  | "backgroundColorText"
  | "textColorText"
  | "borderColorText"
  | "buttonTitle"
  | "primaryButtonTitle"
  | "secondaryButtonTitle"
  | "linkTitle"
  | "assignmentStatusColorTitle"
  | "pieChartTitle"
  | "completedText"
  | "pendingText"
  | "overdueText"
  | "bordersTitle"
  | "shadowsTitle"
  | "sizeText"
  | "colorText"
  | "poweredByText"
  | "loginPoweredByLogoDark"
  | "loginPoweredByLogoLight"
  | "loginPixelsText"
  | "loginLightMode"
  | "loginDarkMode"
  | "loginLightThemed"
  | "loginDarkThemed"
  | "inputFieldsSettingsTitle"
  | "cardsTitle"
  | "cardsSubtitle"
  | "thumbnailTransparencyText"
  | "progressBarTitle"
  | "notStartedBarText"
  | "inProgressBarText"
  | "completedBarText"
  | "contentTypeColourTitle"
  | "coursesText"
  | "surveysText"
  | "policiesText"
  | "overdueTitle"
  | "dateTitle"
  // portal-translation
  | "mainMenu"
  | "adminPortalMenu"
  | "navbar"
  | "find&replace"
  | "editTranslation"
  | "headerText"
  | "assignmentsText"
  | "formText"
  | "infoText"
  | "passwordResetText"
  | "portalGridText"
  | "addPortalModalText"
  | "editLanguagesText"
  | "gpcText"
  | "homeText"
  | "loginText"
  // portal-pages
  | "portalPagesText"
  | "portalPagesDsc"
  | "login"
  | "home"
  | "certificates"
  | "profile"
  | "visibleDsc"
  // portal-setting
  | "portalSettingsText"
  | "portalSettingsDsc"
  | "editPortalSettings"
  | "btnParentPortal"
  | "btnSubPortal"
  | "connectedPortals"
  // user-attributes
  | "userAttributesText"
  | "userAttributesDsc"
  | "attributesAdded"
  | "addNewAttribute"
  | "editAttribute"
  | "editAttributeBtn"
  | "order"
  | "attribute"
  | "attributeKey"
  | "dataType"
  | "mandatory"
  | "btnEdit"
  | "btnAll"
  | "showRows"
  | "btnPrevious"
  | "btnNext"
  | "mandatoryText"
  | "viewOnlyText"
  | "editableText"
  | "attributeSettings"
  | "availableText"
  | "activeText"
  | "orderNumber"
  | "editAttributeHeader"
  | "btnAddNewAttribute";

export const TRANSLATION_TAB_IDS = [
  "appFrame",
  "home",
  "login",
  "new-password",
  "forgot-password",
  "portal-design",
  "portal-translation",
  "portal-pages",
  "portal-settings",
  "portal-configuration",
  "user-attributes",
] as const;
export type TranslationTabId = (typeof TRANSLATION_TAB_IDS)[number];
